// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__27_U2","header":"PatientBlock_header__1rpjk","label":"PatientBlock_label__1nnbj","option":"PatientBlock_option__1MinU"};